import {Enum} from "~/enums/index";

export default new Enum({
    NOT_FETCHED: "NOT_FETCHED",
    FETCHING: "FETCHING",
    FETCHED: "FETCHED",
});
